module.exports = __webpack_public_path__ + "static/media/arrow-right-regular.85183f5d.svg";